import { ReportHandler } from 'web-vitals';
import { trackEvent } from './analytics';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    const sendToGa = (metric: { name: string; value: number; rating?: string }) => {
      trackEvent('web_vital', {
        name: metric.name,
        value: metric.value,
        ...(metric.rating && { rating: metric.rating }),
      });
    };
    getCLS((m) => {
      onPerfEntry?.(m);
      sendToGa(m as any);
    });
    getFID((m) => {
      onPerfEntry?.(m);
      sendToGa(m as any);
    });
    getFCP((m) => {
      onPerfEntry?.(m);
      sendToGa(m as any);
    });
    getLCP((m) => {
      onPerfEntry?.(m);
      sendToGa(m as any);
    });
    getTTFB((m) => {
      onPerfEntry?.(m);
      sendToGa(m as any);
    });
  });
};

export default reportWebVitals;
